import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocalStoreService, SessionRepository } from '@frontend-site/shared/core';
import { HybridCommunicationService } from '@frontend-site/shared/hybrid';
import { PDialogFooterBtnActionType } from '@frontend-site/ui/components';
import { MatDialogRef } from '@angular/material/dialog';
import { Account } from '@frontend-site/shared/data';
import { UserService } from '@frontend-site/users/domain';

@Component({
    selector: 'p-switch-account-dialog',
    templateUrl: './switch-account-dialog.component.html',
    styleUrls: ['./switch-account-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchAccountDialogComponent implements OnInit {
    name: string = '';
    selectedCompanyName: string = '';
    selectedCompanyId: string | number = '';
    company$ = this.userService.getCompanies();

    constructor(
        private dialogRef: MatDialogRef<SwitchAccountDialogComponent>,
        private sessionRepository: SessionRepository,
        private readonly hybridCommunicationService: HybridCommunicationService,
        private readonly userService: UserService,
        private readonly localStorage: LocalStoreService
    ) {}

    ngOnInit(): void {
        this.selectedCompanyName = this.sessionRepository.applicationConfig?.companyName || '';
        this.name = this.sessionRepository.applicationConfig?.user.email || '';
    }

    get footerConfig(): { text: string; type?: PDialogFooterBtnActionType; click?: () => void }[] {
        return [
            {
                text: 'Actions.apply',
                click: () => this.save()
            },
            {
                text: 'Actions.cancel',
                type: PDialogFooterBtnActionType.Close
            }
        ];
    }

    save(): void {
        this.dialogRef.close();
        const data = { id: this.selectedCompanyId, name: this.selectedCompanyName };
        this.localStorage.saveData(`${this.name}.selectedCompany`, data);
        this.hybridCommunicationService.sendSwitchAccount(data);

        setTimeout(() => {
            window.location.replace('/site/rdx/project');
        });
    }

    changeValue(id: string | number, companies: Account[]): void {
        this.selectedCompanyName = companies.find((item) => item.id === id)?.name ?? '';
        this.selectedCompanyId = id;
    }
}
